<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HY8i6b/tc-custom/9781429989022.jpg?1725288276467" alt="This image is the cover for the book All My Patients Kick and Bite"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">All My Patients Kick and Bite
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>The highly amusing, uplifting and entertaining follow-up to </i>All My Patients Have Tales</b><br/><br/>In this second collection by our intrepid vet, Jeff Wells has his work cut out for him when he learns that<br/>llamas do not take kindly to having their toenails trimmed, dog owners in the medical field can be a real pain, Scottish Highland cattle stick together and just might run a vet out of their enclosure, and fixing an overly amorous burro often needs to be prioritized. Told with Wells's trademark humor and gentle touch, these and many other heartwarming, heartbreaking, funny and strange stories will give readers a whole new appreciation for those who care for our pets.<br/>.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeff Wells
      </h2>
      
      <p class="authorDescription body article"><P>JEFF WELLS, DVM is a practicing veterinarian in the foothills of Colorado. A graduate of Iowa State University's College of Veterinary Medicine, Dr. Wells has cared for many types of animals. <I>All My Patients Have Tales </I>was the winner of two Colorado Independent Publisher's Awards and a National Independent Publisher's Award.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0fa17538